export default "<p>edit-announcement works!</p>";